enum DepartmentFieldNames {
  Name = 'name',
  Description = 'description',
  Color = 'color',
  ParentDepartment = 'parentDepartment',
  ResultingHierarchy = 'resultingHierarchy',
  Manager = 'manager',
  Members = 'members',
  MembersList = 'membersList',
  AccessGroups = 'accessGroups',
  AccessGroupsList = 'accessGroupsList',
  Tasks = 'tasks',
  Interventions = 'interventions',
  BasicInformationTitle = 'basic-information-title',
  OrganizationStructureTitle = 'organization-structure-title',
  MembersAccessTitle = 'members-access-title',
  LinkedTasksTitle = 'linked-tasks-title',
  LinkedInterventionsTitle = 'linked-interventions-title',
}

export default DepartmentFieldNames;
